export enum FactsScreenToastMessages {
  TMS_UPDATE_SUCCESS_MESSAGE = 'Successfully updated TMS',
  TMS_UPDATE_FAIL_MESSAGE = 'TMS update failed',
  NDC_UPDATE_SUCCESS_MESSAGE = 'Successfully updated NDC',
  NDC_UPDATE_FAIL_MESSAGE = 'NDC update failed',
  TMS_HISTORY_DELETE_MESSAGE = 'Successfully deactivated selected TMS future value',
  NDC_HISTORY_DELETE_MESSAGE = 'Successfully deactivated selected NDC future value',
}
